import *  as axios from 'axios';
import * as R from 'ramda';
import * as ActionTypes from '../../constants/actiontypes/backoffice/dossiers';
import * as urls from '../../constants/webapi/backoffice/dossiers';
import * as partnerUrls from '../../constants/webapi/partner/partner';
import { getAuthenticationUrl } from '../../constants/webapi/auth';


export function fetchUsersByRole(role, pageNumber, search, partnerId = "", type, sortBy, sortDesc) {
    const page = parseInt(pageNumber);
    if (!R.isNil(pageNumber) && isNaN(page)) {
        throw new Error("pageNumber must be null or an integer");
    }

    return (dispatch) => {
        dispatch({ type: ActionTypes.FETCH_USERS_DOSSIERS_REQUEST, role: role });
        return axios.get(urls.usersByRoleUrl(role, pageNumber, search, partnerId, type, sortBy, sortDesc))
            .then((response) => {
                dispatch({
                    type: ActionTypes.FETCH_USERS_DOSSIERS_SUCCESS,
                    data: response.data
                });
            })
            .catch((error) => {


                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypes.FETCH_USERS_DOSSIERS_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}


export function fetchAllPartners() {
    return (dispatch) => {
        dispatch({ type: ActionTypes.FETCH_PARTNERS_DOSSIERS_REQUEST });
        return axios.get(partnerUrls.partnersByUrl())
            .then((response) => {
                dispatch({
                    type: ActionTypes.FETCH_PARTNERS_DOSSIERS_SUCCESS,
                    data: response.data
                });
            })
            .catch((error) => {


                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypes.FETCH_PARTNERS_DOSSIERS_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}


export function setFilterGlobal(filter) {

    return {
        type: ActionTypes.SET_DOSSIER_FILTER,
        data: filter
    };

}
